<template>
  <div>
    <el-container class="px-3 mt-4">
      <mvmSearch :client="false" @onSearch="onSearch" />
    </el-container>
    <el-table :data="mvms" style="width: 100%" :row-class-name="statusClass" height="85vh">
      <el-table-column prop="AssetNo" label="機台編號" width="80" />
      <el-table-column prop="description" label="機台說明" />
      <el-table-column prop="client.name" label="客戶" />
      <el-table-column prop="locate.name" label="放置地址" />
      <el-table-column prop="model.name" label="型號" />
      <el-table-column prop="user.name" label="巡補員" />

      <el-table-column label="動作">
        <template slot-scope="scope">
          <el-button size="small" @click="deploy(scope.row)">註冊</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-drawer :visible.sync="drawer" :before-close="handleClose" :size="'90%'" direction="btt">
      <div class="text-center">
        <h1>請以QRCODE 掃描器掃描</h1>
        <qrcode-vue :value="mvm" level="H" size="300" margin="30" />
        <h3>uid: {{ uid }}</h3>
        <h3>機型: {{ model.name }}</h3>
        <el-button @click="drawer = false">關閉</el-button>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { getMvms, updateMvm, search, mvmNotDeployed, getMvmNotRegist } from '@/api/mvms';
import mvmSearch from '@/views/mvms/components/select.vue';
import QrcodeVue from 'qrcode.vue';
const methods = {
  async init() {},

  async onSearch(condition) {
    this.condition = condition;
    this.mvms = await getMvmNotRegist(this.condition);
  },

  async deploy(mvm) {
    this.uid = mvm.uid;
    this.model = mvm.model;
    const ivm_api = `${process.env.VUE_APP_BASE_API}`.replace('/api', '/adminapi').replace('localhost:8000', 'localhost:8000');
    const setting = {
      ivm_api,
      uid: mvm.uid,
      wholesaler: mvm.wholesaler,
    };
    this.mvm = JSON.stringify(setting);

    this.drawer = true;
  },
  handleClose(done) {
    done();
  },
  statusClass({ row, index }) {
    switch (row.Status) {
      case 4:
        return 'warning-row';
      case 3:
        return 'warning-row';
      case 2:
        return 'offline';
      case 1:
        return 'success-row';
      default:
        return '';
    }
  },
};
export default {
  components: {
    QrcodeVue,
    mvmSearch,
  },
  data() {
    return {
      mvms: [],
      drawer: false,
      mvm: null,
      uid: '',
      model: '',
      condition: {
        company_id: -10000,
        client_id: -10000,
      },
    };
  },
  created() {
    this.init();
  },
  methods,
};
</script>
<style>
.el-table .warning-row {
  background: oldlace;
}

.el-table .offline {
  background: #fcbdbd;
  /* color: #f0f9eb; */
}

.el-table .success-row {
  background: #f0f9eb;
}
</style>
